/* @ngInject */
export default function jsonTextarea() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link(_scope, _el, attrs, ctrl) {
      if (!attrs.placeholder) {
        attrs.$set('placeholder', JSON.stringify({
          name: 'EXAMPLE CONFIG',
          type: 'placeholder',
          value: 140,
          active: false,
        }, null, 2));
      }
      ctrl.$validators.invalidJson = (value) => {
        try {
          JSON.parse(value);
        } catch {
          return false;
        }
        return true;
      };
    }
  };
}
